<template>
	<div class="checkInQuery">
    <!-- 固定栏 -->
    <div class="fixed-content">
      <!-- tabBtn -->
      <div class="tabBtn">
        <mt-navbar class="navBar" v-model="selected">
          <mt-tab-item class="tabBtnNav1" id="1">在宿</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="2">不在宿</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="3">24小时无活动</mt-tab-item>
        </mt-navbar>
      </div>
    </div>

    <!-- 内容栏 -->
      <div class="scroll-content scroll-content1">
          <div class="noData" v-if="list.length == 0">
              <div style="padding-bottom: 7rem;">
                  <img src="static/images/default-null.png"  alt="">
                  <p>暂时无相关数据</p>
              </div>
          </div>
          <div class="tabContent" v-if="list.length > 0">
            <div class="grid" style="padding-left: 0;padding-right: 0;">
              <div class="gridWarp bg-appStyle color-fff">
                <div class="gridCell flex-1 bold">姓名</div>
                <div class="gridCell flex-1 bold" v-if="selected != 3">状态</div>
                <div class="gridCell flex-1 bold" v-if="selected == 3">最后方向</div>
                <div class="gridCell flex-1 bold">楼栋</div>
                <div class="gridCell flex-1 bold">最后时间</div>
              </div>

              <div>
                <div class="gridWarp bg-fff" v-for="(item, index) in list" :key="index">
                  <div class="gridCell flex-1">{{item.name}}</div>
                  <div class="gridCell flex-1" v-if="selected != 3">{{item.inDormStatus}}</div>
                  <div class="gridCell flex-1" v-if="selected == 3">
                    <span v-if="item.inOutFlag == 1">进</span>
                    <span v-else-if="item.inOutFlag == 2">出</span>
                    <span v-else>无</span>
                  </div>
                  <div class="gridCell flex-1">{{item.areaName}}</div>
                  <div class="gridCell flex-1">
                    <span v-if="item.actionTime">{{item.actionTime}}</span>
                    <span v-else>无</span>
                  </div>
                </div>
              </div>

            </div>
        </div>
      </div>
      
    </div>
</template>

<script>

import Vue from 'vue'
import { mapGetters } from "vuex";
import { Navbar, TabItem } from 'mint-ui';
import { Loadmore } from 'mint-ui';
import { InfiniteScroll } from 'mint-ui';
import { Toast } from 'mint-ui';
import { MessageBox } from 'mint-ui';
import api from "../fetch/api";


import service from "@/fetch/service";
import * as types from '@/vuex/types';
export default {
  components: {
    Navbar,
    TabItem
  },
  data() {
    return {
      Url: types.URL,
      selected: '1', //默认当前的tab 页面
      list: [] //数据
    };
  },
  created() {
    this.getDatas();
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    'selected': function() {
      this.list = [];
      this.getDatas();
    }
  },
  methods: {
    //一行只能显示4个字 多余的换行
    lineFourText: function (str, num) {
      if (!str) return ''
      let newStr = ''
      for (let index = 0; index < str.length; index++) {
        newStr += str[index]
        if ((index + 1) % num == 0) {
          newStr += '<br />'
        }
      }
      return newStr
    },
    getDatas() { 
      this.$store.dispatch("setLoadingState", true);
      service
      .findSqTeacherAttend({
        status: this.selected,  //状态:1:在宿；2:不在宿；3:48小时无活动记录
      })
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        if (res.success) {
          this.list = res.result;
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        Toast(error.data.msg);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
$serachInput-height: px2rem(100px);
$gridCell-height: px2rem(70px);
$mes-height: px2rem(120px);
$other-height: px2rem(180px);
$cutLine-height: px2rem(20px);

$content1Height: px2rem(70px);
$content2Height: px2rem(200px);
.font-size-14px {
  font-size: 14px !important;
}
.mint-tab-item-label {
  font-size: 14px !important;
}
.checkInQuery {
  .fixed-content {
    height: 60px !important;
  }
  .scroll-content1 {
    top: calc(#{$content1Height + $cutLine-height}) !important;
  }
  .scroll-content2 {
    top: calc(#{$content2Height}) !important;
  }
  .scroll-content3 {
    top: calc(#{$content2Height}) !important;
  }
}
.cut-line {
  height: $cutLine-height;
  background: #f5f5f5;
}
.serachInput {
  height: $serachInput-height;
  // position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 px2rem(20px);
  background: #fff;
  //下拉框
  .dropdownBox {
    display: flex;
    justify-content: center;
    align-items: center;
    .dropdown {
      width: px2rem(115px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .serach {
    height: 70%;
    margin-left: px2rem(25px);
    padding: 0 px2rem(10px);
    border-radius: px2rem(10px);
    display: flex;
    justify-content: center;
    // flex: 1;
    align-self: center;
    input {
      height: 100%;
      // flex: 1;
      width: px2rem(220px);
    }
    .deleteBtn {
      width: px2rem(35px);
      height: px2rem(35px);
      align-self: center;
    }
    .serachBtn {
      width: px2rem(80px);
      height: px2rem(50px);
      line-height: px2rem(50px);
      background: #03a9f4;
      align-self: center;
      border-radius: px2rem(10px);
      text-align: center;
    }
    .serachBtn1 {
      width: px2rem(200px);
    }
  }
}
.gridWarp {
    display: flex;
    padding: px2rem(20px) 0;
    border-bottom: 1px solid #ececec;
    .gridCell:last-child {
      border-right: none;
    }
    .gridCell {
      font-size: 13px;
      line-height: 18px;
      // flex: 1;
      text-align: center;
      // height: $gridCell-height;
      // line-height: $gridCell-height;
      p {
        color: #333;
        font-size: 13px;
      }
      div {
        font-size: 13px;
      }
    }
}
.flex-1 {
  flex: 1;
}
.flex-basis-60 {
  flex-basis: px2rem(110px) !important;
  padding: 0 px2rem(10px);
}
.checkInQuery .tabBtn .navBar .tabBtnNav1 {
  padding: px2rem(30px) 0 !important;
  font-size: 14px;
}
.mobileSelect .content .btnBar .cancel, 
.mobileSelect .content .btnBar .ensure {
  font-size: 14px;
}
.mint-loadmore-text {
  font-size: 14px;
}
.mint-msgbox-btn {
  font-size: 14px;
}
.listBox {
  .bg-f9b625 {
    background: #f9b625;
  }
  display: flex;
  position: relative;
  .typeStateBtn {
    position: absolute;
    top: 0;
    right: 0;
    width: px2rem(124px);
    height: px2rem(102px);
  }
  //缩略图
  .thumbnail {
      width: px2rem(136px);
      height: px2rem(136px);
      margin-right: px2rem(30px);
      border-radius: px2rem(5px);
  }
  //缩略图-长方形
  .thumbnail-max {
      width: px2rem(210px);
      height: px2rem(136px);
      margin-right: px2rem(26px);
      border-radius: px2rem(5px);
  }
  //基本信息栏
  .mesList {
      flex: 1;
      .title {
          display: flex;
          align-items: center;
          flex: 1;
          //列表 标签
          .label {
              flex: none;
              display: inline-block;
              padding: 0 px2rem(15px);
              height: px2rem(32px);
              line-height: px2rem(32px);
              color: #fff;
              border-radius: px2rem(3px);
              margin-right: px2rem(16px);
              margin-left: px2rem(20px);
              font-size: px2rem(22px);
          }
      }
      //标签靠右-标签
      .title-label-right {
          justify-content: space-between;
      }
      p {
          color: #666;
          font-size: px2rem(26px);
          margin-top: px2rem(25px);
      }
  }
}

</style>


// WEBPACK FOOTER //
// DormitoryManagement.vue?888b9282